export const MAX_FILE_UPLOAD_SIZE_MB = 40;
export const MAX_FILE_UPLOAD_COUNT = 10;
export const ACCEPTED_FILE_UPLOAD_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.heic', '.heif', '.pdf', '.doc', '.docx', '.xls', '.xlsx'];
export const ACCEPTED_FILE_UPLOAD_TYPES = ACCEPTED_FILE_UPLOAD_EXTENSIONS.join(',');

export interface FileUploadValidationResult {
  isValid: boolean;
  error?: string;
}

export const validateFileUpload = (filesToAdd: File[], currentFileCount = 0): FileUploadValidationResult => {
  const unsupported = filesToAdd.filter((file) => {
    const fileName = file.name.toLowerCase();
    return !ACCEPTED_FILE_UPLOAD_EXTENSIONS.some((extension) => fileName.endsWith(extension));
  });

  if (unsupported.length > 0) {
    return {
      isValid: false,
      error: `Unsupported file type. Allowed types: ${ACCEPTED_FILE_UPLOAD_EXTENSIONS.join(', ')}. Remove: ${unsupported.map((file) => file.name).join(', ')}`,
    };
  }

  const oversized = filesToAdd.filter((file) => file.size > MAX_FILE_UPLOAD_SIZE_MB * 1024 * 1024);

  if (oversized.length > 0) {
    return {
      isValid: false,
      error: `Files must be ${MAX_FILE_UPLOAD_SIZE_MB} MB or smaller. Remove: ${oversized.map((file) => file.name).join(', ')}`,
    };
  }

  if (currentFileCount + filesToAdd.length > MAX_FILE_UPLOAD_COUNT) {
    return {
      isValid: false,
      error: `You can attach a maximum of ${MAX_FILE_UPLOAD_COUNT} files.`,
    };
  }

  return { isValid: true };
};
